import type { Ga4Metrics } from '@marketing-hub/shared';
import { defaultKpiRange, isoDateUtc } from './kpiRollup';

export type Ga4Snapshot = { snapshot_date: string; metrics: Ga4Metrics };

export { defaultKpiRange, isoDateUtc };

export function sumGa4LastDays(snapshots: Ga4Snapshot[], days: number): Ga4Metrics {
  const cutoff = new Date();
  cutoff.setUTCDate(cutoff.getUTCDate() - days);
  const cutoffStr = isoDateUtc(cutoff);

  let sessions = 0;
  let active_users = 0;
  let conversions = 0;
  let engagement_rate = 0;
  let n = 0;

  for (const s of snapshots) {
    if (s.snapshot_date < cutoffStr) continue;
    sessions += s.metrics.sessions;
    active_users += s.metrics.active_users;
    conversions += s.metrics.conversions;
    engagement_rate += s.metrics.engagement_rate;
    n += 1;
  }

  return {
    sessions,
    active_users,
    conversions,
    engagement_rate: n > 0 ? engagement_rate / n : 0,
  };
}
